import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module16World.css';
import '../../Animations.css';
import Draggable from 'react-draggable';

import Learn from '../../Learn/Learn';
import Practice from '../../Unit4/Module16/Ballon/BallonPractice';
import PracticeRecording from '../../Unit4/Practice/PracticeRecording';
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import FollowTheBeatModule6 from '../../FollowTheBeat/FollowTheBeatModule6.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';
import loading from './../../loading-gif-png-5.gif';
import Module11Practice from '../../Unit3/Module11/Practice';

const Module16World = () => {
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);

  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module16 } = useSelector((state) => state.module16, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module16Images/Unit4_Mod1BG.png');
  const closedChest6 = generateImageUrl('images/Module1Images/Chest_Closed.svg');
  const openChest = generateImageUrl('images/Module1Images/Chest_Open.svg');
  const animal = generateImageUrl('images/Module1Images/Crab.svg');
  const crab = generateImageUrl('images/Module1Images/Crab2.gif');
  const progressbar0 = generateImageUrl('images/Module1Images/ProgressBar_0.svg');
  const progressbar1 = generateImageUrl('images/Module1Images/ProgressBar_1-4.svg');
  const progressbar2 = generateImageUrl('images/Module1Images/ProgressBar_2-4.svg');
  const progressbar3 = generateImageUrl('images/Module1Images/ProgressBar_3-4.svg');
  const progressbarCompleted = generateImageUrl('images/Module1Images/ProgressBar_Completed.svg');
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.svg');
  const keyReward = generateImageUrl('images/Module1Images/Key_Full.png');
  const SurfBoardBlue = generateImageUrl('images/Module1Images/Reward_SurfBoardBlue.svg');
  const SurfBoardRed = generateImageUrl('images/Module1Images/Reward_SurfBoardRed.svg');
  const StandTacos = generateImageUrl('images/Module16Images/TacoStand.png');
  const StandHotDogs = generateImageUrl('images/Module16Images/HotDogStand.png');
  const BeachChairBlue = generateImageUrl('images/Module16Images/BeachchairBlue.png');
  const BeachChairRed = generateImageUrl('images/Module16Images/BeachchairRed.png');
  const SnowConeBlue = generateImageUrl('images/Module16Images/SnowconeBlue.png');
  const SnowConeRed = generateImageUrl('images/Module16Images/SnowconeRed.png');
  const FloatationBall = generateImageUrl('images/Module16Images/FloatationBall.png');
  const FrisbeeBlue = generateImageUrl('images/Module16Images/FrisbeeBlue.png');
  const FerrisWheelRed = generateImageUrl('images/Module16Images/DailyReward_FerrisWheel1@3x.png');
  const FerrisWheelBlue = generateImageUrl('images/Module16Images/DailyReward_FerrisWheel2@3x.png');
  const ArcadeBlue = generateImageUrl('images/Module16Images/ArcadeBlue.png');
  const ArcadePurple = generateImageUrl('images/Module16Images/ArcadePurple.png');
  const CrabwearGlasses = generateImageUrl('images/Module1Images/Reward_Glasses.svg');
  const CrabWearMustash = generateImageUrl('images/Module1Images/Reward_Mustache.svg');
  const CrabHawaiian = generateImageUrl('images/Module16Images/CrabHawaiian.png');
  const CrabSuit = generateImageUrl('images/Module16Images/CrabSuit.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = '88f7834da7a999396a5d968c78de/480.m3u8';
  const present = generateImageUrl('images/Images/Gift.png');

  const [chestopen, setChestOpen] = useState(closedChest6);
  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayPracticeReview, setDisplayPracticeReview] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [singTime, setSingTime] = useState('');
  const [practice, setPractice] = useState('');
  const [practiceReview, setPracticeReview] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState(false);
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [keyAnimationState, setKeyAnimationState] = useState('');
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);
  const [playChestOpen, setPlayChestOpen] = useState(false);
  const [playChestShake, setPlayChestShake] = useState(false);
  const [chestAnimationState, setChestAnimationState] = useState('');
  const [showCrab, setShowCrab] = useState(false);
  const [crabState, setCrabState] = useState('');
  const [playYouAreAwesome, setPlayYouAreAwesome] = useState(false);
  const [displayFTB, setDisplayFTB] = useState(false);
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial1_2, setFTBTutorial1_2] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');

  const [dayFinished, setDayFinished] = useState('');
  const [ftbIntro, setFtbIntro] = useState('');
  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [awesomeJob, setAwesomeJob] = useState('');
  const [audioReady, setAudioReady] = useState(false);
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [closingGIF, setClosingGIF] = useState('');
  const [practiceMessage, setPracticeMessage] = useState('');
  const [practiceConversation, setPracticeConversation] = useState('');
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  function getGifs() {
    setAwesomeJob(getVideo('appfiles/greet/greet_awesome_job.gif', login));

    setFTBCount(getVideo('appfiles/greet/countingCrab.gif', login));
    setPracticeIntro(getVideo('appfiles/greet/greet_practice_intro.gif', login));
    setLearnIntro(getVideo('appfiles/greet/greet_learn_intro.gif', login));
    setFtbIntro(getVideo('appfiles/greet/ftb_intro.gif', login));
    setCelebrateIntro(getVideo('appfiles/greet/greet_celebrate_intro.gif', login));

    setFTBInstruction(getVideo('appfiles/manners/manners_ftb_instructions.mp3', login));

    setFTBInstructionGIF(getVideo('appfiles/greet/ftb_crab_instructions.gif', login));

    setFTBMusic(getVideo('appfiles/feelings/ftb greet with clapping.m4a', login));
    setClosingGIF(getVideo('appfiles/eye_contact/crab_awesome.gif', login));
    setDayFinished(getVideo('appfiles/manners/manners_day_finished.mp3', login));

    setPracticeMessage(getVideo('appfiles/greet/greet_special_message.gif', login));
    setPracticeConversation(getVideo('appfiles/manners/manners_let_watch.gif', login));

    if (!module16.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/manners/ftb_walkthrough_touch_right_clap.mp3', login));
      setFTBTutorial1_2(getVideo('appfiles/manners/ftb_walkthrough_touch_left_clap.mp3', login));
      setFTBTutorial2(getVideo('appfiles/manners/ftb_walkthrough_together.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/greet/ftb_walkthrough_audio.mp3', login));
    }

  }

  useEffect(() => {
    getGifs();
  }, []);

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const createGameDetails = (flag, reward, coin) => {
    const game_detail = module16.game_details;
    if (flag) {
      const flags = { flag, lastUpdated: new Date().toJSON() };
      game_detail.moduleFlags.push(flags);
    }
    if (coin >= 0) {
      game_detail.tokens_earned = coin;
    }
    if (reward) {
      const dailyRewards = [];
      for (const key in module16.rewards) {
        if (module16.rewards[key].unlocked === true) {
          const rewards = {
            type: key,
            x_multiplier: module16.rewards[key].x,
            y_multiplier: module16.rewards[key].y,
          };
          dailyRewards.push(rewards);
        }
      }
      game_detail.dailyRewards = dailyRewards;
    }
    dispatch({ type: 'MODULE16_SET_GameDetials', payload: game_detail });
  };

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "Manners",
				day_completed: module16.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  const updateDB = async () => {
    const myInit = {
      body: {
        id: module16.moduleID,
        day_completed: module16.day_completed,
        step_completed: module16.stepCompleted,
        game_details: JSON.stringify(module16.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setAnimalVoice(null);
          setCrabState(closingGIF);
          setShowCrab(true);
          setPlayYouAreAwesome(true);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          module16.stepCompleted === 'notstarted' ||
          module16.stepCompleted === 'learn' ||
          module16.stepCompleted === 'practice' ||
          module16.stepCompleted === 'celebrate' ||
          module16.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'Manners',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module16.stepCompleted]);

  useEffect(() => {
    if (module16.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module16.coins);
      updateDB();
    }
  }, [module16.coins]);

    useEffect(() => {
    if((module16.reviewIcon === true || login.grade === "Teacher Mode") && module16.sectionCompleted === 4 ) {
        updateProgress();
        module16.sectionCompleted = 0;
    }
    }, [module16.sectionCompleted])

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (module16.currentday <= module16.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE16_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE16_SET_KEY', payload: 4 });
      if (module16.currentday === 4 || module16.currentday === 8) {
        dispatch({ type: 'MODULE16_SET_KEY', payload: 5 });
      }
    } else {
      if (module16.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE16_TOGGLE_REVIEW_ICON', payload: false });
      if (module16.currentday === 4 && module16.day_completed === 3) {
        if (module16.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 0 });

        } else if (module16.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 1 });

        } else if (module16.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 2 });
 
        } else if (module16.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 3 });

        } else if (module16.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 4 });
        } else if (module16.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE16_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module16.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 0 });
 
        } else if (module16.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 1 });

        } else if (module16.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 2 });
 
        } else if (module16.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 3 });

        } else if (module16.stepCompleted === 'celebrate') {
          if (module16.currentday === 8 && module16.day_completed === 7) {
            dispatch({ type: 'MODULE16_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE16_SET_KEY', payload: 4 });
          }
        } else if (module16.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE16_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module16.stepCompleted]);

  let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
  let [dropZone, setDropZone] = useState(false);
  let [displayRewardVideo, setDisplayRewardVideo] = useState(false);
  let [rewardVideo, setRewardVideo] = useState('');

  const selectReward = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE16_SET_REWARD${module16.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE16_SET_REWARD${module16.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE16_SET_REWARD${module16.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE16_SET_REWARD${module16.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true, module16.coins);
                  if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE16_SET_DAY_UNLOCK${module16.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE16_SET_dayCompleted',
                    payload: module16.currentday === 8 ? 9 : module16.currentday,
                  });
                  dispatch({
                    type: 'MODULE16_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
              onError={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true, module16.coins);
                  dispatch({
                    type: `MODULE16_SET_DAY_UNLOCK${module16.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE16_SET_dayCompleted',
                    payload: module16.currentday === 8 ? 9 : module16.currentday,
                  });
                  dispatch({
                    type: 'MODULE16_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                switch (module16.currentday){
                  case 1:
                    if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_Mustache.mp4'))
                    }
                    else{
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_Glasses.mp4'))
                    }
                    break;
                  case 2:
                    if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_SurfBoardRed.mp4'))
                    }
                    else{
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_SurfBoardBlue.mp4'))
                    }
                    break;
                  case 3:
                    if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_RedChair.mp4'))
                    }
                    else{
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_BlueChair.mp4'))
                    }
                    break;
                  case 4:
                    if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_SnowConeBlue.mp4'))
                    }
                    else{
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_SnowConePink.mp4'))
                    }
                    break;
                  case 5:
                    if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_Frisbee.mp4'))
                    }
                    else{
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_BeachBall.mp4'))
                    }
                    break;
                  case 6:
                    if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_FerrisWheel1.mp4'))
                    }
                    else{
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_FerrisWheel2.mp4'))
                    }
                    break;
                  case 7:
                    if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReawrd_ArcadePurple.mp4'))
                    }
                    else{
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReawrd_ArcadeBlue.mp4'))
                    }
                    break;
                  case 8:
                    if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_FoodCartHotdog.mp4'))
                    }
                    else{
                      setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_DailyReward_FoodCartTaco.mp4'))
                    }
                    break;
                }
                document.getElementById('rewardItemLeft').style.display = 'none'
                document.getElementById('rewardItemRight').style.display = 'none'
                setDisplayRewardVideo(true);
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={CrabHawaiian}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE16_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE16_SET_PRIZE2`, payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={CrabSuit}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE16_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE16_SET_PRIZE1`, payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE16_SET_COIN',
                    payload: module16.coins - 100,
                  });
                  setChestOpen(closedChest6);
                  setPlayChestOpen(false);
                  setDisplayRewardVideo(false);
                });
              }}
              onError={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE16_SET_COIN',
                    payload: module16.coins - 100,
                  });
                  setChestOpen(closedChest6);
                  setPlayChestOpen(false);
                  setDisplayRewardVideo(false);
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                  setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_SpecialReward_1.mp4'))
                }
                else{
                  setRewardVideo(generateImageUrl('media/Module16/Unit4_Mod1_SpecialReward_2.mp4'))
                }
                document.getElementById('rewardItemLeft').style.display = 'none'
                document.getElementById('rewardItemRight').style.display = 'none'
                setDisplayRewardVideo(true);
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module16.currentday) {
      case 1:
        setRewardOption1(CrabWearMustash);
        setRewardOption2(CrabwearGlasses);
        break;
      case 2:
        setRewardOption1(SurfBoardRed);
        setRewardOption2(SurfBoardBlue);
        break;
      case 3:
        setRewardOption1(BeachChairRed);
        setRewardOption2(BeachChairBlue);
        break;
      case 4:
        setRewardOption1(SnowConeBlue);
        setRewardOption2(SnowConeRed);
        break;
      case 5:
        setRewardOption1(FrisbeeBlue);
        setRewardOption2(FloatationBall);
        break;
      case 6:
        setRewardOption1(FerrisWheelRed);
        setRewardOption2(FerrisWheelBlue);
        break;
      case 7:
        setRewardOption1(ArcadePurple);
        setRewardOption2(ArcadeBlue);
        break;
      case 8:
        setRewardOption1(StandHotDogs);
        setRewardOption2(StandTacos);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [keyIcon]);

  const displayReview = () => {
    if (module16.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/manners/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module16.currentday === 4) {
              dispatch({ type: 'MODULE16_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module16.day_completed === 9) {
              navigate('/manners/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/manners/manners_demo.m4a', login)
    let video = getVideo(`appfiles/manners/learn_video.mp4`, login)
    switch (module16.currentday) {
      case 1:
        setLearn(
          <Learn
            video='e25f19367120e3377ae0da169af5/480.m3u8'
            songVideo={video}
            closingVideo='f547ae500e322fef3c25eb692433/480.m3u8'
            destiny='/manners'
            song={song}
            back='/manners'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE16_SET_stepCompleted'
            module={module16}
            module16={true}
            animal={crab}
            learnVideo1={'Module16/day1_learn_eye.mp4'}
            learnVideo2={'2c166625db12f7a53a08877aa918/480.m3u8'}
            learnVideo3={'Module16/day1_learn_tall.mp4'}
            learnVideo4={'fa6d8aea78311edffc48049a781c/480.m3u8'}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='8fa34303e0aa7c7d0a33f01fe589/480.m3u8'
            songVideo={video}
            closingVideo='7cb962c86aa7b83a94f0e3653d65/480.m3u8'
            destiny='/manners'
            song={song}
            back='/manners'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE16_SET_stepCompleted'
            module={module16}
            module16={true}
            animal={crab}
            learnVideo1={'5f6bed7d607ec07407f8197ca0f8/480.m3u8'}
            learnVideo2={'d35a91d9d459e9e2a618baecfbfc/480.m3u8'}
            learnVideo3={'Module16/day2_learn_sorry.mp4'}
            learnVideo4={'d62bd9cb820fb2ae72474893095c/480.m3u8'}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='e8406c36ba9543896f5b7f78d012/480.m3u8'
            songVideo={video}
            closingVideo='Module16/day3_learn_part2.mp4'
            destiny='/manners'
            song={song}
            back='/manners'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE16_SET_stepCompleted'
            module={module16}
            module16={true}
            animal={crab}
            learnVideo1={'87d2b4f1b8e0a7f6c723d019d883/480.m3u8'}
            learnVideo2={'5c573d2f563e3d8ac40adf5f550e/480.m3u8'}
            learnVideo3={'38925d641a77afc7cdefd656623d/480.m3u8'}
            learnVideo4={'98b69b3e2f14a9c87f46ecf459b0/480.m3u8'}
          />
        );
        break;
      default:
        // setAnimalVoice(getVideo('appfiles/manners/manners_learn_intro.mp3', login));
        // // setDisplayVoice(true)
        // setCrabState(learnIntro);
        // setShowCrab(true);
        await GetUserVideo(`userfiles/${module16.StudentID}/manners_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module16.currentday - 4]}/greet_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/manners'
                    song={data}
                    back='/manners'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE16_SET_stepCompleted'
                    module={module16}
                    instrumental={getVideo('appfiles/manners/manners_final.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/manners'
                    song={song}
                    back='/manners'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE16_SET_stepCompleted'
                    module={module16}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    const optionSorry = {
      img: generateImageUrl('images/Module16Images/practice/I_m sorry.png'),
      title: 'I am sorry',
      audioPrompt: 'appfiles/manners/option_sorry.mp3',
    };

    const optionExcuseMe = {
      img: generateImageUrl('images/Module16Images/practice/excuse me.png'),
      title: 'Excuse me',
      audioPrompt: 'appfiles/manners/option_excuse_me.mp3',
    };

    const optionBeSilent = {
      img: generateImageUrl('images/Module16Images/practice/be silent.png'),
      title: 'Be silent and listen',
      audioPrompt: 'appfiles/manners/option_be_silent.mp3',
    };

    const optionCalmVoice = {
      img: generateImageUrl('images/Module16Images/practice/use a calm voice.png'),
      title: 'Use a calm voice',
      audioPrompt: 'appfiles/manners/option_calm_voice.mp3',
    };

    const optionLoudVoice = {
      img: generateImageUrl('images/Module16Images/practice/use a loud voice.png'),
      title: 'Use an outdoor voice',
      audioPrompt: 'appfiles/manners/option_loud_voice.mp3',
    };

    const optionWhisper = {
      img: generateImageUrl('images/Module16Images/practice/whisper.png'),
      title: 'Whisper',
      audioPrompt: 'appfiles/manners/option_whisper.mp3',
    };

    const optionPlease = {
      img: generateImageUrl('images/Module16Images/practice/please.png'),
      title: 'Please',
      audioPrompt: 'appfiles/manners/option_please.mp3',
    };

    const optionThankYou = {
      img: generateImageUrl('images/Module16Images/practice/thank you.png'),
      title: 'Thank You',
      audioPrompt: 'appfiles/manners/option_thank_you.mp3',
    };
    const wantSnowCone = {
      prompt: 'If you want a snow cone, you should say',
      audioPrompt: 'appfiles/manners/practice_say_snow_cone.mp3',
      correctMatch: optionPlease,
      incorrectMatches: [optionSorry, optionExcuseMe],
    };

    const buySnowCone = {
      prompt: 'If you buy a snow cone, you should',
      audioPrompt: 'appfiles/manners/practice_how_snow_cone.mp3',
      correctMatch: optionCalmVoice,
      incorrectMatches: [optionWhisper, optionBeSilent],
    };

    const throwFrisbee = {
      prompt:
        'If you throw your frisbee and it accidentally hits your friend, you should say',
      audioPrompt: 'appfiles/manners/practice_say_beach.mp3',
      correctMatch: optionSorry,
      incorrectMatches: [optionThankYou, optionExcuseMe],
    };

    const safeWater = {
      prompt:
        'When you are listening to your parent telling you to be safe in the water, you should',
      audioPrompt: 'appfiles/manners/practice_how_beach.mp3',
      correctMatch: optionBeSilent,
      incorrectMatches: [optionWhisper, optionLoudVoice],
    };

    const ferrisWheel = {
      prompt:
        'If the ferris wheel worker tells you to have a good time on the ride, you should say',
      audioPrompt: 'appfiles/manners/practice_say_ferris_wheel.mp3',
      correctMatch: optionThankYou,
      incorrectMatches: [optionExcuseMe, optionSorry],
    };

    const topFerrisWheel = {
      prompt:
        `If you are at the top of the ferris wheel and you want your parent's attention to look up at you, you should`,
      audioPrompt: 'appfiles/manners/practice_how_ferris_wheel.mp3',
      correctMatch: optionLoudVoice,
      incorrectMatches: [optionCalmVoice, optionBeSilent],
    };

    const bumpPerson = {
      prompt:
        'If you accidentally bump into someone at the arcade, you should say',
      audioPrompt: 'appfiles/manners/practice_say_arcade.mp3',
      correctMatch: optionExcuseMe,
      incorrectMatches: [optionPlease, optionThankYou],
    };

    const tellSecret = {
      prompt:
        'If you need to quietly tell your friend something, but you do not want everyone around you to hear, you should',
      audioPrompt: 'appfiles/manners/practice_how_arcade.mp3',
      correctMatch: optionWhisper,
      incorrectMatches: [optionLoudVoice, optionBeSilent],
    };

    const foodDelivered = {
      prompt: 'When your food is delivered, you should say',
      audioPrompt: 'appfiles/manners/practice_say_food.mp3',
      correctMatch: optionThankYou,
      incorrectMatches: [optionPlease, optionExcuseMe],
    };

    const tellFamilySecret = {
      prompt:
        'If you need to say something to your family, but you do not want the people sitting at the table next to you to hear, you should',
      audioPrompt: 'appfiles/manners/practice_how_food.mp3',
      correctMatch: optionWhisper,
      incorrectMatches: [optionLoudVoice, optionBeSilent],
    };

    const actSnowCone = {
      prompt: '',
      audioPrompt: 'appfiles/manners/practice_act_snow_cone.mp3',
      correctMatch: null,
      incorrectMatches: null,
    };

    const actBeach = {
      prompt: '',
      audioPrompt: 'appfiles/manners/practice_act_beach.mp3',
      correctMatch: null,
      incorrectMatches: null,
    };

    const actFerrisWheel = {
      prompt: '',
      audioPrompt: 'appfiles/manners/practice_act_ferris_wheel.mp3',
      correctMatch: null,
      incorrectMatches: null,
    };

    const actArcade = {
      prompt: '',
      audioPrompt: 'appfiles/manners/practice_act_arcade.mp3',
      correctMatch: null,
      incorrectMatches: null,
    };

    const actFood = {
      prompt: '',
      audioPrompt: 'appfiles/manners/practice_act_food.mp3',
      correctMatch: null,
      incorrectMatches: null,
    };

    const titles = [
      'Step 1: How I act',
      'Step 2: What I say',
      'Step 3: How I say it',
    ];

    const options = [
      [actSnowCone, wantSnowCone, buySnowCone],
      [actBeach, throwFrisbee, safeWater],
      [actFerrisWheel, ferrisWheel, topFerrisWheel],
      [actArcade, bumpPerson, tellSecret],
      [actFood, foodDelivered, tellFamilySecret],
    ];
    const instructions = [
      [
        'appfiles/manners/practice_snowcone_greeting.mp4',
        'appfiles/manners/practice_snowcone_ask.mp4',
        'appfiles/manners/practice_snowcone_respond.mp4',
        'appfiles/manners/practice_snowcone_close.mp4',
      ],
      [
        'appfiles/manners/practice_beach_greeting.mp4',
        'appfiles/manners/practice_beach_ask.mp4',
        'appfiles/manners/practice_beach_respond.mp4',
        'appfiles/manners/practice_beach_close.mp4',
      ],
      [
        'appfiles/manners/practice_ferris_wheel_greeting.mp4',
        'appfiles/manners/practice_ferris_wheel_ask.mp4',
        'appfiles/manners/practice_ferris_wheel_respond.mp4',
        'appfiles/manners/practice_ferris_wheel_close.mp4',
      ],
      [
        'appfiles/manners/practice_arcade_greeting.mp4',
        'appfiles/manners/practice_arcade_ask.mp4',
        'appfiles/manners/practice_arcade_respond.mp4',
        'appfiles/manners/practice_arcade_close.mp4',
      ],
      [
        'appfiles/manners/practice_food_greeting.mp4',
        'appfiles/manners/practice_food_ask.mp4',
        'appfiles/manners/practice_food_respond.mp4',
        'appfiles/manners/practice_food_close.mp4',
      ],
      
    ];
    const names = [
      [
        'manners_practice_greet_5.mp4',
        'manners_practice_ask_5.mp4',
        'manners_practice_close_5.mp4',
      ],
      [
        'manners_practice_greet_6.mp4',
        'manners_practice_ask_6.mp4',
        'manners_practice_close_6.mp4',
      ],
      [
        'manners_practice_greet_7.mp4',
        'manners_practice_ask_7.mp4',
        'manners_practice_close_7.mp4',
      ],
      [
        'manners_practice_greet_8.mp4',
        'manners_practice_ask_8.mp4',
        'manners_practice_close_8.mp4',
      ],
      [
        'manners_practice_greet_9.mp4',
        'manners_practice_ask_9.mp4',
        'manners_practice_close_9.mp4',
      ],
    ];
    const texts = [
      [
        `Press record and say, "Hello"`,
        `Press record and say your favorite flavor.`,
        `Press record and say, "Goodbye!"`,
      ],
      [
        `Press record and say, "Hi!"`,
        `Press record and say your favorite thing to do at the beach.`,
        `Press record and say, "Goodbye!"`,
      ],
      [
        `Press record and say, "It is good to meet you!"`,
        `Press record and say if you want the ferris wheel to go fast or slow.`,
        `Press record and say, "See you later!"`,
      ],
      [
        `Press record and say, "Good afternoon!"`,
        `Press record and say your favorite game.`,
        `Press record and say, "Bye!"`,
      ],
      [
        `Press record and say, "It is good to meet you!"`,
        `Press record and say what you would like to eat.`,
        `Press record and say, "See ya!"`,
      ],
    ];
    const voices = [
      [
        'appfiles/manners/practice_snowcone_greeting_prompt.mp3',
        'appfiles/manners/practice_snowcone_ask_prompt.mp3',
        'appfiles/manners/practice_snowcone_close_prompt.mp3',
      ],
      [
        'appfiles/manners/practice_beach_greeting_prompt.mp3',
        'appfiles/manners/practice_beach_ask_prompt.mp3',
        'appfiles/manners/practice_snowcone_close_prompt.mp3',,
      ],
      [
        'appfiles/manners/practice_ferris_wheel_greeting_prompt.mp3',
        'appfiles/manners/practice_ferris_wheel_ask_prompt.mp3',
        'appfiles/manners/practice_ferris_wheel_close_prompt.mp3',,
      ],
      [
        'appfiles/manners/practice_arcade_greeting_prompt.mp3',
        'appfiles/manners/practice_arcade_ask_prompt.mp3',
        'appfiles/manners/practice_arcade_close_prompt.mp3',,
      ],
      [
        'appfiles/manners/practice_ferris_wheel_greeting_prompt.mp3',
        'appfiles/manners/practice_food_ask_prompt.mp3',
        'appfiles/manners/practice_food_close_prompt.mp3',,
      ],
    ];
    const exampleVideos = [
      '3fdbbcc43c87c92ae2d9a8b58e1a/480.m3u8',
      'a206033e9e68ceebfd64f6f631a3/480.m3u8',
      'a5c56f28753f1a2e91c91a373e94/480.m3u8',
      '7a77d2fbfa33ac22810725c228a4/480.m3u8',
      'b06fdefc2247638b56e9bf9cde38/480.m3u8',
    ];
    switch (module16.currentday) {
      case 1:
        setPractice(
          <Practice
            video1={'abd64c0a328fd92eb206d40486c5/480.m3u8'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            module={module16}
            animal={crab}
            ended={() => {
              setDisplayPractice(false);
              setDisplayPracticeReview(true);
            }}
          />
        );
        setPracticeReview(
            <Module11Practice
              reviewVideo={'82c1529514f22fead55c5b24c6ed/480.m3u8'}
              setDisplayPractice={setDisplayPracticeReview}
              background={generateImageUrl("images/Module11Images/Unit3_Mod1_Background-1.png")}
              stepComplete={'MODULE16_SET_stepCompleted'}
              module={module16}
              unit4={true}
          />
        );
        break;
      case 2:
        setPractice(
          <Practice
            video1={'05010b46b43f26296b2fa9f752cb/480.m3u8'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            module={module16}
            animal={crab}
            ended={() => {
              setDisplayPractice(false);
              setDisplayPracticeReview(true);
            }}
          />
        );
        setPracticeReview(
          <Module11Practice
            reviewVideo={'f2c8df6139f9d0c5a9bdc86a817f/480.m3u8'}
            setDisplayPractice={setDisplayPracticeReview}
            background={generateImageUrl("images/Module11Images/Unit3_Mod1_Background-1.png")}
            stepComplete={'MODULE16_SET_stepCompleted'}
            module={module16}
            unit4={true}
          />
        );
        break;
      case 3:
        setPractice(
          <Practice
            video1={'41e029c0912bfcfa8eab1be15b1d/480.m3u8'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            module={module16}
            animal={crab}
            ended={() => {
              setDisplayPractice(false);
              setDisplayPracticeReview(true);
            }}
          />
        );
        setPracticeReview(
          <Module11Practice
            reviewVideo={'82c1529514f22fead55c5b24c6ed/480.m3u8'}
            setDisplayPractice={setDisplayPracticeReview}
            background={generateImageUrl("images/Module11Images/Unit3_Mod1_Background-1.png")}
            stepComplete={'MODULE16_SET_stepCompleted'}
            module={module16}
            unit4={true}
          />
        );
        break;
      default:
        // setAnimalVoice(getVideo('appfiles/manners/manners_practice_intro.mp3', login));
        // // setDisplayVoice(true);
        // setCrabState(practiceIntro);
        // setShowCrab(true);
        setPractice(
          <PracticeRecording
            score={'practice_manners'}
            score_target={2}
            options={options[module16.currentday - 4]}
            titles={titles}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE16_SET_stepCompleted'}
            module={module16}
            animal={crab}
            module16={true}
            instructions={instructions[module16.currentday - 4]}
            names={names[module16.currentday - 4]}
            texts={texts[module16.currentday - 4]}
            voices={voices[module16.currentday - 4]}
            influencerid={influencers[module16.currentday - 4]}
            introduction={getVideo('appfiles/manners/manners_let_practice.gif', login)}
            introductionMP3={'appfiles/manners/manners_practice_conversation.mp3'}
            practiceConversation={practiceConversation}
            practiceMessage={practiceMessage}
            awesomeJob={awesomeJob}
            practiceConversationAudio={'media/Module16/watch_conversation.mp3'}
            practiceMessageAudio={'appfiles/greet/greet_practice_special_message.mp3'}
            awesomeJobAudio={'appfiles/eye_contact/crab_awesome_job.mp3'}
            exampleVideo={exampleVideos[module16.currentday - 4]}
          />
        );
        break;
    }
    setDisplayPractice(true);
  };

  const openFTB = async () => {
    switch (module16.currentday) {
      case 1:
        break;
      case 2:
        break;
      case 3:
        break;

      default:
        // setCrabState(ftbIntro);
        // setAnimalVoice(getVideo('appfiles/feelings/feelings_ftb_intro.mp3', login));
        // // setDisplayVoice(true)
        // setShowCrab(true);
        break;
    }
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = '5a1f965559d59329360e3c3a8bd7/480.m3u8';
    const celebrateVideo2 = '5de394fbe42993fb93073c32c82d/480.m3u8';
    const celebrateVideo3 = 'ee94aac87c5fa2c0106c3a47895a/480.m3u8';

    switch (module16.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module16}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE16'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module16}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE16'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module16}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE16'}
          />
        );
        break;
      default:
        let audios = ['appfiles/manners/manners_celebrate_please.mp3',
        'appfiles/manners/manners_celebrate_thank.mp3',
        'appfiles/manners/manners_celebrate_calm.mp3',
        'appfiles/manners/manners_celebrate_smile.mp3',
        'appfiles/manners/manners_celebrate_body_tall.mp3']
        let text = [`Record yourself in an excited voice and say, "I am awesome because I say please!"`,
        `Record yourself in an excited voice and say, "I am awesome because I say thank you!"`,
        `Record yourself in an excited voice and say, "I am awesome because I talk in a calm voice."`,
        `Record yourself in an excited voice and say, "I am awesome because I smile!"`,
        `Record yourself in an excited voice and say, "I am awesome because I keep my body tall!"`]
        // setCrabState(celebrateIntro);
        // setShowCrab(true);
        // setAnimalVoice(getVideo('appfiles/greet/greet_celebrate_intro.mp3', login));
        // setDisplayVoice(true)
        let voice1 = getVideo(audios[module16.currentday-4], login);
        let voice2 = getVideo('appfiles/greet/greet_celebrate_say_thanks.mp3', login);
        let voice3 = getVideo('appfiles/eye_contact/crab_awesome_job.mp3', login);
        let animalGIF = getVideo('appfiles/feelings/feelings_joyful.gif', login);
        let animalVoice = getVideo('appfiles/feelings/feelings_joyful_jingle_intro.mp3', login);
        await GetUserVideo(`influencers/${influencers[module16.currentday - 4]}/greet_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              world3={true}
              module={module16}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              animalGIF={animalGIF}
              animalVoice={animalVoice}
              text={text[module16.currentday-4]}
              name={`manners_celebration_surprise_${
                module16.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={awesomeJob}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={'MODULE16'}
            />
          );
        });
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = '22fa1cdaf9b5aea0864c36ea9025/480.m3u8';
    let noteVideo = getVideo('appfiles/manners/manners_student_notes.mp4', login);
    let singingMusic = getVideo('appfiles/manners/manners_demo.m4a', login);
    let instrumental = getVideo('appfiles/manners/manners_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module16}
        moduleNum='MODULE16'
        name='manners'
        instrumental={instrumental}
        instrumentalURL={'appfiles/manners/manners_final.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/greet_affirmation.mp4`,
      },
      {
        video: `userfiles/${module16.StudentID}/manners_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/greet_affirmation.mp4`,
      },
      {
        video: `userfiles/${module16.StudentID}/manners_celebration_surprise_7.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/greet_affirmation.mp4`,
      },
      {
        video: 'appfiles/manners/practice_ferris_wheel_greeting.mp4',
      },
      {
        video: `userfiles/${module16.StudentID}/manners_practice_greet_7.mp4`,
      },
      {
        video: 'appfiles/manners/practice_ferris_wheel_ask.mp4',
      },
      {
        video: `userfiles/${module16.StudentID}/manners_practice_ask_7.mp4`,
      },
      {
        video: 'appfiles/manners/practice_ferris_wheel_respond.mp4',
      },
      {
        video: `userfiles/${module16.StudentID}/manners_practice_close_7.mp4`,
      },
      {
        video: 'appfiles/manners/practice_ferris_wheel_close.mp4',
      },
      {
        video: `userfiles/${module16.StudentID}/manners_celebration_surprise_8.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/greet_affirmation.mp4`,
      },
      {
        video: `userfiles/${module16.StudentID}/manners_celebration_surprise_9.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/greet_affirmation.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; ++i){
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }
  
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/manners/manners_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });

    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const keyAnimation = () => {
    setKeyAnimationState('fade-out');
    sleep(1000).then(() => {
      chestShakeAnimation();
    });
  };

  const chestShakeAnimation = () => {
    setChestAnimationState('shakeChest');
    setPlayChestShake(true);
    sleep(1400).then(() => {
      setKeyIcon(false);
      setChestOpen(openChest);
      setPlayChestOpen(true);
      rewardsMovingAnimation();
    });
  };

  const rewardsMovingAnimation = () => {
    sleep(1000).then(() => {
      setDisplayReward(true);
    });
  };

  const closeDay8Video = () => {
    setIntroVideo(AfterCelebrateVideo9);
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setShowCrab(false);
  };

  const playButtonAudio = () => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  };

  const onStop = (reward, data) => {
    const position = { x: data.x / clientWidth, y: data.y / clientHeight };

    if (reward === 1 || reward === 2) {
      dispatch({
        type: `MODULE16_SET_PRIZE${reward}_POSITION`,
        payload: position,
      });
    } else {
      dispatch({
        type: `MODULE16_SET_REWARD${reward}_POSITION`,
        payload: position,
      });
    }
  };

  return (
    <>
      {playYouAreAwesome && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() =>
            module16.currentday === 8
              ? closeDay8Video()
              : navigate('/manners/navigation')
          }
        >
          <source src={dayFinished}></source>
        </audio>
      )}

      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: 'MODULE16_SET_COIN',
              payload: module16.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {playChestOpen && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module1Videos/chest_open_items_out.mp3')
            }
          ></source>
        </audio>
      )}

      {playChestShake && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module1Videos/chest_shake.mp3')
            }
          ></source>
        </audio>
      )}

      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            // setCrabState(crab)
            setAudioReady(false);
            setShowCrab(false);
            setDisplayVoice(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!showCrab && displayLearn && learn}
      {!showCrab && displayPractice && practice}
      {!showCrab && displayPracticeReview && practiceReview}
      {!showCrab && displayFTB && (
        <FollowTheBeatModule6
          unit4={true}
          setDisplayFTB={setDisplayFTB}
          awesomeJob={awesomeJob}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial1_2={ftbTutorial1_2}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE16_SET_stepCompleted'} 
          module={module16}
          score={'ftb_manners'}

        />
      )}
      {displaySingingTime && singTime}
      {!showCrab && displayCelebrate && celebrate}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayPracticeReview) ||
        showCrab) && (
        <div
          className='feelingsWorldBody'
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={togglePopup}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world Image'
              onClick={() => {
                navigate('/manners/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                setPrize(false);
                setChestAnimationState('shakeChest');
                setPlayChestShake(true);
                sleep(1400).then(() => {
                  setChestOpen(openChest);
                  setPlayChestOpen(true);
                  sleep(1000).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <img
            className='animateCrab11'
            src={crab}
            alt='crab Icon'
          />
          {showCrab && !audioReady && <img alt='' id='loading' src={loading} />}
          {showCrab && (
            <img
              className='animateCrab11'
              style={audioReady ? {} : { display: 'none' }}
              src={crabState}
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowCrab(false)}
            ></img>
          )}
          <img
            className='closedChest6'
            src={chestopen}
            id={chestAnimationState}
            alt='closed Chest Icon'
          />

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'
            />
            {module16.coins < 10 && (
              <h5 className='scoretext1'>{module16.coins}</h5>
            )}
            {module16.coins >= 10 && module16.coins < 100 && (
              <h5 className='scoretext10'>{module16.coins}</h5>
            )}
            {module16.coins >= 100 && (
              <h5 className='scoretext100'>{module16.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module16.currentday === 4 || module16.currentday === 8 ? (
            <div className='progressBar'>
              <img
                className='progressKey'
                src={keys5[module16.keys]}
                alt='crab Icon'
              />
              <h3 className='progresstext'>{module16.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar'>
              <img
                className='progressKey'
                src={keys4[module16.keys]}
                alt='crab Icon'
              />
              <h3 className='progresstext'>{module16.keys}/4</h3>
            </div>
          )}

          {!showCrab && !module16.reviewIcon && !coinIcon && !disPlayPrize && !dropZone && (
            <div className='actionBtnDiv'>
              {module16.currentday === 4 &&
                module16.stepCompleted === 'notstarted' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={SingingTimeIcon}
                    alt='learn button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        displaySinging();
                        setCheckStep('singingtime');
                      });
                    }}
                  />
                )}
              {module16.currentday !== 4 &&
                module16.stepCompleted === 'notstarted' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='learn button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}

              {module16.stepCompleted === 'learn' && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={practiceBtn}
                  alt='practice button'
                  onClick={() => {
                    setTouchButton(true);
                    sleep(500).then(() => {
                      openPractice();
                      setCheckStep('practice');
                    });
                  }}
                />
              )}
              {module16.stepCompleted === 'practice' && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={ftbBtn}
                  alt='celebrate button'
                  onClick={() => {
                    setTouchButton(true);
                    sleep(500).then(() => {
                      openFTB();
                      setCheckStep('followthebeat');
                    });
                  }}
                />
              )}
              {module16.stepCompleted === 'followthebeat' && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={celebrateBtn}
                  alt='celebrate button'
                  onClick={() => {
                    setTouchButton(true);
                    sleep(500).then(() => {
                      openCelebrate();
                      setCheckStep('celebrate');
                    });
                  }}
                />
              )}
              {module16.stepCompleted === 'singingtime' && (
                <img
                  className='actionBtn2'
                  id='bounceIcons'
                  src={learnBtn}
                  alt='singing button'
                  onClick={() => {
                    setTouchButton(true);
                    sleep(500).then(() => {
                      openLearn();
                      setCheckStep('learn');
                    });
                  }}
                />
              )}
            </div>
          )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {module16.reviewIcon === false && (
                <img
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showCrab &&
            !displayReward &&
            (
              <div className='actionBtnDiv'>
                {module16.reviewIcon && (
                <img
                  src={reviewBtn}
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  alt='review button'
                  onClick={() => {
                    setTouchButton(true);
                    sleep(500).then(() => {
                      setReviewIcon(!reviewIcon);
                    });
                  }}
                  />)}
                  {showReward && (
                    <img
                      src={rewardBtn}
                      className='actionBtn4'
                      alt='review button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          keyAnimation();
                        });
                      }}
                  />)}
                {module16.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {keyIcon && !coinIcon && !disPlayPrize && (
            <img
              src={keyReward}
              id={keyAnimationState}
              style={{
                width: '150px',
                height: '50px',
                marginLeft: '-75px',
                zIndex: 10,
              }}
              className='rewardsIcon'
              alt='reward key'
              onClick={() => {
                keyAnimation();
              }}
            />
          )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          <div className='rewardArea'>
            {module16.rewards.SurfBoardRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.SurfBoardRed.x * clientWidth,
                  y: module16.rewards.SurfBoardRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(21, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${SurfBoardRed})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.SurfBoardBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.SurfBoardBlue.x * clientWidth,
                  y: module16.rewards.SurfBoardBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(22, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${SurfBoardBlue})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.StandHotDogs.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.StandHotDogs.x * clientWidth,
                  y: module16.rewards.StandHotDogs.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(81, data);
                }}
              >
                <div
                  className='moveCart1'
                  style={{ backgroundImage: `url(${StandHotDogs})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.StandTacos.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.StandTacos.x * clientWidth,
                  y: module16.rewards.StandTacos.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(82, data);
                }}
              >
                <div
                  className='moveCart2'
                  style={{ backgroundImage: `url(${StandTacos})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.BeachChairRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.BeachChairRed.x * clientWidth,
                  y: module16.rewards.BeachChairRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(31, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${BeachChairRed})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.BeachChairBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.BeachChairBlue.x * clientWidth,
                  y: module16.rewards.BeachChairBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(32, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${BeachChairBlue})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.SnowConeBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.SnowConeBlue.x * clientWidth,
                  y: module16.rewards.SnowConeBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(41, data);
                }}
              >
                <div
                  className='moveSmallReward16'
                  style={{ backgroundImage: `url(${SnowConeBlue})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.SnowConeRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.SnowConeRed.x * clientWidth,
                  y: module16.rewards.SnowConeRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(42, data);
                }}
              >
                <div
                  className='moveSmallReward26'
                  style={{ backgroundImage: `url(${SnowConeRed})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.FrisbeeBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.FrisbeeBlue.x * clientWidth,
                  y: module16.rewards.FrisbeeBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(51, data);
                }}
              >
                <div
                  className='moveReward16'
                  style={{ backgroundImage: `url(${FrisbeeBlue})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.FloatationBall.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.FloatationBall.x * clientWidth,
                  y: module16.rewards.FloatationBall.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(52, data);
                }}
              >
                <div
                  className='moveReward26'
                  style={{ backgroundImage: `url(${FloatationBall})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.FerrisWheelRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.FerrisWheelRed.x * clientWidth,
                  y: module16.rewards.FerrisWheelRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(61, data);
                }}
              >
                <div
                  className='moveBigReward16'
                  style={{ backgroundImage: `url(${FerrisWheelRed})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.FerrisWheelBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.FerrisWheelBlue.x * clientWidth,
                  y: module16.rewards.FerrisWheelBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(62, data);
                }}
              >
                <div
                  className='moveBigReward26'
                  style={{ backgroundImage: `url(${FerrisWheelBlue})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.ArcadePurple.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.ArcadePurple.x * clientWidth,
                  y: module16.rewards.ArcadePurple.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(71, data);
                }}
              >
                <div
                  className='moveArcadeReward1'
                  style={{ backgroundImage: `url(${ArcadePurple})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.ArcadeBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.ArcadeBlue.x * clientWidth,
                  y: module16.rewards.ArcadeBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(72, data);
                }}
              >
                <div
                  className='moveArcadeReward2'
                  style={{ backgroundImage: `url(${ArcadeBlue})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.CrabwearGlasses.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.CrabwearGlasses.x * clientWidth,
                  y: module16.rewards.CrabwearGlasses.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(12, data);
                }}
              >
                <div
                  className='moveCharaterReward2'
                  style={{ backgroundImage: `url(${CrabwearGlasses})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.CrabWearMustash.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.CrabWearMustash.x * clientWidth,
                  y: module16.rewards.CrabWearMustash.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(11, data);
                }}
              >
                <div
                  className='moveCharaterReward1'
                  style={{ backgroundImage: `url(${CrabWearMustash})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.CrabHawaiian.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.CrabHawaiian.x * clientWidth,
                  y: module16.rewards.CrabHawaiian.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(1, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${CrabHawaiian})` }}
                ></div>
              </Draggable>
            )}

            {module16.rewards.CrabSuit.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module16.rewards.CrabSuit.x * clientWidth,
                  y: module16.rewards.CrabSuit.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(2, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${CrabSuit})` }}
                ></div>
              </Draggable>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default Module16World;
